import { render } from "./Protected.vue?vue&type=template&id=4b89b190&scoped=true"
import script from "./Protected.vue?vue&type=script&lang=js"
export * from "./Protected.vue?vue&type=script&lang=js"

import "./Protected.vue?vue&type=style&index=0&id=4b89b190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b89b190"]])

export default __exports__